import {
  createResource,
  postResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL = 'favorite'

const FAVORITE_GENERAL_ADD_URL = prefixAPI('/add/', MODEL)
const FAVORITE_GENERAL_REMOVE_URL = prefixAPI('/remove/', MODEL)
const FAVORITE_GENERAL_LIST_URL = prefixAPI('/list/{?limit,offset,content_type_label,catalog_type}', MODEL)

export const favoriteGeneralAddResource = createResource(FAVORITE_GENERAL_ADD_URL, postResource)
export const favoriteGeneralRemoveResource = createResource(FAVORITE_GENERAL_REMOVE_URL, postResource)
export const favoriteGeneralListResource = createResource(FAVORITE_GENERAL_LIST_URL)
